import type { FormEvent, FunctionComponent } from 'react';
import { Button, Form, FormField, InputGroup, TextInput } from '@george-labs.com/design-system';
import { useCallback } from 'react';

import { buildEnvironmentSwitchUrl } from '../../services';
import styles from './CustomEnvironmentInput.module.scss';

export const CustomEnvironmentInput: FunctionComponent = () => {
    const redirectToEnvironment = useCallback((event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { customEnvironment } = Object.fromEntries(new FormData(event.currentTarget));
        const environmentUrl = buildEnvironmentSwitchUrl(customEnvironment as string);
        window.location.replace(environmentUrl);
    }, []);

    return (
        <Form onSubmit={redirectToEnvironment}>
            <FormField
                required
                className={`px-2 ${styles.formField}`}
                label="Custom"
                labelClassName="pt-2"
                input={
                    <InputGroup append={<Button type="submit">Go</Button>}>
                        <TextInput required name="customEnvironment" />
                    </InputGroup>
                }
            />
        </Form>
    );
};
